import { render } from "./inAppNotifications.vue?vue&type=template&id=157744fc&ts=true"
import script from "./inAppNotifications.vue?vue&type=script&lang=ts"
export * from "./inAppNotifications.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\equistasi\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__